import { Product } from '@app/router/types';

export const productSuperSocialBr: Product = {
    Account: {
        ResponsibleGaming: true,
        MyMessages: true,
        ChangePhone: true,
        HelpAndSupport: true,
        MyAccount: true,
        ChangePassword: true,
        SwitchLanguage: true,
        LicencePreferences: false,
        LoginHistory: false,
    },
    Sport: true,
    Lottery: false,
    News: true,
    Free2Play: {
        BingoBash: false,
        SuperSpin: true,
        FreeGamesInfo: true,
        SportCaller: false,
        SuperMillion: false,
        CalendarGame: false,
        SuperShot: false,
        TopManager: false,
        FantasticDuels: false,
    },
    GrowthMarketing: {
        NewBettingSiteSerbia: false,
    },
    BonusAndComms: {
        LpBonus: true,
        Notifications: true,
    },
    Games: true,
    CasinoLive: false,
    Virtual: false,
    Shops: false,
    Loyalty: {
        Supercoins: false,
    },
};
